"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MenuTab = function MenuTab(props) {
  var icon = props.icon,
      title = props.title,
      open = props.open,
      onToggle = props.onToggle,
      children = props.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'menu-tab'
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: 'menu-tab-header',
    onClick: function onClick(e) {
      if (onToggle) onToggle(e);
    }
  }, icon && icon, /*#__PURE__*/_react.default.createElement("span", {
    className: 'menu-tab-content'
  }, title), open && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'caret-up'],
    color: 'white'
  }), !open && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'caret-down'],
    color: 'white'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: 'menu-tab-body'
  }, open && children));
};

MenuTab.propTypes = {
  icon: _propTypes.default.element,
  title: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  open: _propTypes.default.bool,
  onToggle: _propTypes.default.func
};
var _default = MenuTab;
exports.default = _default;